import { activityFetch as fetch } from '../../../components/feedback/requestActivity'
import React, { useState } from 'react';

export default function ProjectForm() {
    const [projectName, setProjectName] = useState("");
    const [projectDescription, setProjectDescription] = useState("");
    const [url, setUrl] = useState("");
    const [github, setGithub] = useState("");
    // 필요한 만큼의 상태들을 선언합니다.

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            // 여기서 서버로 데이터를 전송합니다.
            // 예시로 아래에 POST 요청을 보내는 코드를 작성했습니다.
            // 실제 구현에서는 서버의 API 엔드포인트와 맞게 수정해야 합니다.
            let response = await fetch('/api/projects', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    projectName,
                    projectDescription,
                    url,
                    github,
                    // 필요한 만큼의 데이터들을 전송합니다.
                })
            });

            if (!response.ok) throw new Error(response.status);
            
            let data = await response.json();
            
            console.log(data);
            
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };

    return (
      <form onSubmit={handleSubmit}>
          <label>
              Project Name:
              <input type="text" value={projectName} onChange={(e) => setProjectName(e.target.value)} />
          </label>
          <label>
              Project Description:
              <textarea value={projectDescription} onChange={(e) => setProjectDescription(e.target.value)} />
          </label>
          <label>
              URL:
              <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
          </label>
          <label>
              Github:
              <input type="text" value={github} onChange={(e) => setGithub(e.target.value)} />
          </label>
          
          {/* 필요한 만큼의 입력필드들을 추가합니다. */}
          
          <button type="submit">Submit</button>

      </form> 
  );
}
